import React, {useMemo, useRef} from 'react'
import {useToggle} from "react-use";
import {createLazyComponent} from "../helpers/createLazyComponent";


const QrScanComponent = createLazyComponent(() => import('./QrScanComponent'))

export const useQrScanner = ({item, doSubmit, timeoutSeconds}) => {
    const qrReaderRef = useRef()
    const [isOpenQRScanner, setIsOpenQRScanner] = useToggle(false)

    const openQRScanner = () => setIsOpenQRScanner(true)
    const closeQRScanner = () => setIsOpenQRScanner(false)

    const qrModal = useMemo(() => {
        if (!isOpenQRScanner) return null
        return (
            <QrScanComponent
                ref={qrReaderRef}
                {...{isOpenQRScanner, setIsOpenQRScanner, doSubmit, item, timeoutSeconds}}
            />
        )
    }, [item, isOpenQRScanner])

    return {qrModal, isOpenQRScanner, openQRScanner, closeQRScanner}
}



